__turbopack_context__.v({
  "link": "links-module-scss-module__fVLFnW__link",
});
